import { Button, makeStyles } from "@material-ui/core";

import DialogCloseIcon from "../assets/icons/dialogclose.png";

const useStyles = makeStyles((theme) => ({
  button: {
    maxWidth: 20,
    maxHeight: 20,
    position: "absolute",
    right: 0,
    paddingRight: 0,
    top: theme.spacing(2),
    color: theme.palette.grey[500],
  },
  icon: {
    width: 15,
    height: 15,
  },
  frame: {
    backgroundColor: theme.gray,
    maxWidth: 35,
    maxHeight: 35,
    minWidth: 35,
    minHeight: 35,
    borderRadius: "0 0 0 12px",
    position: "absolute",
    right: 0,
    top: 0,
    boxShadow: "none",
    color: theme.palette.grey[500],
  },
}));

const DialogCloseButton = ({ onClose, frame }) => {
  const classes = useStyles();
  return (
    <Button
      className={frame ? classes.frame : classes.button}
      onClick={onClose}
      variant={frame ? "contained" : "standard"}
    >
      {" "}
      <img
        src={DialogCloseIcon}
        className={classes.icon}
        alt="close"
        style={{ pointerEvents: "none" }}
      />
    </Button>
  );
};

export default DialogCloseButton;
